module.exports = __webpack_public_path__ + "static/media/logo-bbc-three-2.4941ea89.svg";